import template from './ticketConfirmNotifications.template.html';

/* @ngInject */

export default (
  $q,
  $filter,
  $window,
  $rootScope,
  $timeout,
  $mdDialog,
  cookies,
  accountsService,
  filterService,
  contactsService,
  partnersService,
  uiService,
  ticketService,
  ticketsService,
  messagesService,
  privilegeService,
  ACCOUNT,
  CONTACT,
  PARTNER,
  TICKET
) => {
  const uniq = (model, prop) => _.uniq(_.compact(_.flatten(_.map(model, prop))));
  const diff = (source, target) => _.difference(source, target);

  const boardInitialize = (currentWorkflow, tickets) => {
    const deferred = $q.defer();

    const workflow = currentWorkflow;
    if (!workflow?.stages?.length || !tickets) {
      deferred.reject();
    } else {
      const len = workflow.stages.length;
      const collapsedStages =
        cookies.get(`stBoard${workflow.id}`) &&
        cookies.get(`stBoard${workflow.id}`) !== undefined
          ? cookies.get(`stBoard${workflow.id}`)
          : [];
      for (let i = 0; i < len; i += 1) {
        if (!workflow.stages[i].tickets) {
          workflow.stages[i].tickets = [];
        }
        workflow.stages[i].tickets = workflow.stages[i].tickets.concat(
          _.filter(tickets, {
            idStage: workflow.stages[i].id
          })
        );
        workflow.stages[i].isCollapsed = !collapsedStages.length
          ? false
          : collapsedStages.indexOf(i) > -1;
      }
      deferred.resolve();
    }

    return deferred.promise;
  };

  const boardHeight = (workflow, stagesData, currentAccount) => {
    const windowHeight = angular.element($window).height();
    const nonCollapsedIds = _.map(
      _.filter(workflow.stages, (stage) => !stage.isCollapsed),
      'id'
    );
    const nonCollapsedStagesData = _.filter(
      stagesData?.available,
      (s) => nonCollapsedIds.indexOf(s?.id) > -1
    );
    const ticketsNumber = nonCollapsedStagesData?.length
      ? _.max(_.map(nonCollapsedStagesData, 'count'))
      : 0;
    let ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_BASIC;
    const showAvatars =
      currentAccount?.userInterface?.showTileDealOwner ||
      currentAccount?.userInterface?.showTileDealPartner ||
      currentAccount?.userInterface?.showTileDealClient;
    const showLabels = currentAccount?.userInterface?.showTileLabels;
    const showInfo =
      currentAccount?.userInterface?.showTileDueDate ||
      currentAccount?.userInterface?.showTileValue;
    if (showAvatars && showLabels && showInfo) {
      ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_FULL;
    }
    if (!showAvatars && showLabels && showInfo) {
      ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_BASIC_INFO_LABELS;
    }
    if (!showAvatars && showLabels && !showInfo) {
      ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_BASIC_LABELS;
    }
    if ((showAvatars && !showLabels && !showInfo) || (showAvatars && !showLabels && showInfo)) {
      ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_BASIC_AVATARS;
    }
    if (!showAvatars && !showLabels && showInfo) {
      ticketTileHeight = TICKET.UI.SINGLE_TICKET_HEIGHT_BASIC_INFO;
    }
    const stageMaxHeight = ticketsNumber * ticketTileHeight + TICKET.UI.BOARD_DIFFERENCE_HEIGHT;
    return windowHeight - TICKET.UI.BOARD_HEADER_HEIGHT > stageMaxHeight
      ? { height: `${windowHeight - TICKET.UI.BOARD_HEADER_HEIGHT}px` }
      : { height: `${stageMaxHeight}px` };
  };

  const boardReset = (currentWorkflow) => {
    const workflow = currentWorkflow;
    if (!workflow?.stages?.length) {
      return;
    }
    const len = workflow.stages.length;
    for (let i = 0; i < len; i += 1) {
      workflow.stages[i].tickets = [];
    }
  };

  const cookieFilterName = (idWorkflow) => `stBoardFilter${btoa(idWorkflow)}`;

  const cookieFilterContents = (id) => cookies.get(cookieFilterName(id));

  const cookieFilterRead = (id) =>
    cookieFilterContents(id) ? JSON.parse(cookieFilterContents(id)) : {};

  const stageCollapse = (workflow, currentStage) => {
    const stage = currentStage;
    stage.isCollapsed = !stage.isCollapsed;

    const collapsedStages = [];
    const len = workflow.stages.length;
    for (let i = 0; i < len; i += 1) {
      if (workflow.stages[i].isCollapsed) {
        collapsedStages.push(i);
      }
    }
    cookies.set(`stBoard${workflow.id}`, collapsedStages, { path: '/' });
  };

  const stageProcess = (stages, idStage, count, total, sum) => {
    const stage = _.find(stages, (s) => s.id === idStage);
    if (stage) {
      stage.count += count;
      if (_.isArray(sum) || sum >= 0) {
        stage.sum = Math.round(_.isArray(sum) ? _.first(sum) : sum);
      }
      if (_.isArray(total) || total >= 0) {
        stage.total = _.isArray(total) ? _.first(total) : total;
      } else {
        stage.isLoading = false;
      }
      stage.hasMore = stage.count < stage.total;
    }
  };

  const cookieFilterRemove = (id) => cookies.remove(cookieFilterName(id), { path: '/' });

  const cookieFilterSet = (idWorkflow, idFilter) =>
    cookies.set(cookieFilterName(idWorkflow), JSON.stringify({ idWorkflow, idFilter }), {
      path: '/'
    });

  const cookieFilter = (idWorkflow, filters) => {
    const cookie = cookieFilterRead(idWorkflow);
    if (cookie.idFilter && cookie.idWorkflow === idWorkflow) {
      return _.find(filters, (f) => f.id === cookie.idFilter);
    }
    return null;
  };

  const ticketConfirmNotifications = (event, ticket, stage, allContacts) => {
    const deferred = $q.defer();

    messagesService.getAvailable({ type: ['email', 'sms'] }).then((data) => {
      $mdDialog
        .show({
          targetEvent: event,
          locals: {
            messages: data,
            contacts: _.filter(
              allContacts,
              (c) => ticket.idClients.indexOf(c.id) > -1 && c.isUpdatesAndReminders
            )
          },
          template,
          controllerAs: '$ctrl',
          controller(messages, contacts) {
            const ctrl = this;
            ctrl.contacts = _.sortBy(contacts, (c) => _.indexOf(ticket.idClients, c.id));
            ctrl.messages = [];
            ctrl.model = {};
            ctrl.isReady = false;

            ctrl.setModel = (notifications, value) => {
              if (notifications) {
                ctrl.messages = _.filter(notifications, (m) => {
                  const options = _.find(stage.opMessages, (op) => op.id === m.id);
                  return (
                    stage.idMessages.indexOf(m.id) > -1 &&
                    (!options || options.onEnter === true)
                  );
                });
              }
              ctrl.notifications = [];
              const len = ctrl.messages.length;
              for (let i = 0; i < len; i += 1) {
                ctrl.model[ctrl.messages[i].id] = {};
                const cLen = ticket.idClients.length;
                for (let j = 0; j < cLen; j += 1) {
                  ctrl.model[ctrl.messages[i].id][ticket.idClients[j]] = value;
                }
                ctrl.notifications.push({
                  id: ctrl.messages[i].id,
                  clients: ticket.idClients
                });
              }
            };

            ctrl.setModel(messages, true);
            $timeout(() => {
              ctrl.isReady = true;
            });

            ctrl.cancel = () => {
              ctrl.setModel(null, false);
              ctrl.confirm();
            };

            ctrl.confirm = () => {
              $mdDialog.hide(ctrl.model);
            };
          }
        })
        .then((model) => {
          deferred.resolve(model);
        });
    });

    return deferred.promise;
  };

  const ticketMove = (event, ui, workflow, contacts) => {
    const deferred = $q.defer();

    if (
      !workflow?.stages?.length ||
      !ui?.item?.sortable ||
      ui.item.sortable.isCanceled() ||
      ui.item.sortable.dropindex === undefined
    ) {
      deferred.reject();
    } else {
      const ticket = ui.item.sortable.model;
      const ticketIndexOld = ui.item.sortable.index;
      const ticketIndexNew = ui.item.sortable.dropindex;
      let stage = null;
      const len = workflow.stages.length;

      for (let i = 0; i < len; i += 1) {
        if (
          workflow.stages[i]?.tickets.length >= ticketIndexNew &&
          workflow.stages[i]?.tickets[ticketIndexNew] &&
          workflow.stages[i]?.tickets[ticketIndexNew].id === ticket.id
        ) {
          stage = workflow.stages[i];
          break;
        }
      }

      if (stage?.id) {
        ticket.hasMoved = true;
        ticket.idStage = stage.id;

        ticketsService.clearCache();
        if (
          $rootScope.CurrentAccount.userInterface.confirmAutomatedNotifications &&
          stage.idMessages &&
          stage.idMessages.length &&
          _.filter(stage.idMessages, (m) => {
            const options = _.find(stage.opMessages, (op) => op.id === m);
            return !options || options.onEnter === true;
          }).length &&
          contacts &&
          contacts.length
        ) {
          return ticketConfirmNotifications(event, ticket, stage, contacts).then((model) => {
            ticketService.updateTicket({
              id: ticket.id,
              idStage: ticket.idStage,
              options: model
            });
            deferred.resolve();
          });
        }
        ticketService.updateTicket({
          id: ticket.id,
          idStage: ticket.idStage
        });
      }
      deferred.resolve();
    }

    return deferred.promise;
  };

  const ticketMoved = (workflow, currentTicket) => {
    if (workflow.id === currentTicket.idWorkflow) {
      let fromStageIndex = null;
      let toStageIndex = null;
      let ticketIndex = null;
      let ticket = null;
      const len = workflow.stages.length;
      for (let i = 0; i < len; i += 1) {
        if (workflow.stages[i].id === currentTicket.idStageSrc) {
          ticket = _.find(workflow.stages[i].tickets, (t) => t.id === currentTicket.idTicket);
          ticketIndex = workflow.stages[i].tickets.indexOf(ticket);
          fromStageIndex = i;
        }
        if (workflow.stages[i].id === currentTicket.idStageDst) {
          toStageIndex = i;
        }
      }
      ticket.hasMoved = true;
      workflow.stages[fromStageIndex].tickets.splice(ticketIndex, 1);
      workflow.stages[toStageIndex].tickets.splice(currentTicket.indexDst, 0, ticket);
      uiService.toast({
        user: {
          avatar: currentTicket.avatar,
          name: currentTicket.userName
        },
        text: {
          p1: 'Moved',
          p2: ticket.getName(),
          p3: 'to',
          p4: workflow.stages[toStageIndex].getName()
        }
      });
    }
  };

  const ticketsProcess = (workflowsDataCurrent, ticketsDataCurrent, ticketsDataNew) => {
    const deferred = $q.defer();

    const tickets = ticketsDataCurrent;
    const idAccounts = diff(uniq(ticketsDataNew, 'idOwner'), uniq(tickets.accounts, 'id'));
    if (idAccounts && idAccounts.length) {
      accountsService
        .getSpecific({ ids: idAccounts, isActive: true, fields: ACCOUNT.FIELDS.LIST })
        .then((accounts) => {
          tickets.accounts = tickets.accounts.concat(accounts || []);
        });
    }

    const idContacts =
      privilegeService.showTileDealClient() || privilegeService.confirmAutomatedNotifications()
        ? diff(uniq(ticketsDataNew, 'idClients'), uniq(tickets.contacts, 'id'))
        : null;
    if (idContacts && idContacts.length) {
      contactsService
        .getSpecific({ idContacts, isActive: true, fields: CONTACT.FIELDS.WTF_LIST })
        .then((contacts) => {
          tickets.contacts = tickets.contacts.concat(contacts || []);
        });
    }

    const idPartners = privilegeService.showTileDealPartner()
      ? diff(uniq(ticketsDataNew, 'idPartners'), uniq(tickets.accounts, 'id'))
      : null;
    if (idPartners && idPartners.length) {
      partnersService
        .getSpecific({ ids: idPartners, isActive: true, fields: PARTNER.FIELDS.LIST })
        .then((partners) => {
          tickets.partners = tickets.partners.concat(partners || []);
        });
    }

    boardInitialize(workflowsDataCurrent.current, ticketsDataNew).then(() => {
      deferred.resolve(true);
    });

    return deferred.promise;
  };

  const ticketsLoad = (
    workflowsData,
    stagesData,
    ticketsData,
    ticketSortingOptions,
    filtersData,
    isInitial,
    idStage
  ) => {
    const deferred = $q.defer();

    if (isInitial === true) {
      boardReset(workflowsData.current);
      /* eslint-disable no-param-reassign */
      ticketSortingOptions.active = privilegeService.isTicketMoveAllowed()
        ? ticketSortingOptions.enabled
        : ticketSortingOptions.disabled;
      /* eslint-enable no-param-reassign */
      _.forEach(stagesData.available, (stage) => {
        /* eslint-disable no-param-reassign */
        stage.count = 0;
        stage.total = 0;
        stage.isLoading = false;
        stage.hasMore = true;
        /* eslint-enable no-param-reassign */
      });
    }

    const filterWith = _.find(
      filtersData.available,
      (f) => f.id === _.get(filtersData, 'current.id')
    );
    const isActive = _.isBoolean(filterService.itemIsActiveValue({ filterWith }))
      ? filterService.itemIsActiveValue({ filterWith })
      : true;

    const dataOptions = {
      idWorkflow: workflowsData.current.id,
      idFilter: filtersData.current ? filtersData.current.id : null,
      fields: TICKET.FIELDS.BOARD,
      isActive
    };

    const stagesToLoad = _.filter(
      stagesData.available,
      (s) => s.isLoading === false && s.hasMore === true && (!idStage || s.id === idStage)
    );

    _.forEach(stagesToLoad, (stage) => {
      /* eslint-disable no-param-reassign */
      stage.isLoading = true;
      /* eslint-enable no-param-reassign */
      if (isInitial === true) {
        const optionsCount = angular.copy(dataOptions);
        const optionsSum = angular.copy(dataOptions);
        optionsCount.idStage = stage.id;
        optionsCount.isCount = true;
        optionsSum.idStage = stage.id;
        optionsSum.isSum = true;
        ticketsService.getByWorkflowAndStageCount(optionsCount).then((total) => {
          ticketsService.getByWorkflowAndStageCount(optionsSum).then((sum) => {
            stageProcess(stagesData.available, stage.id, 0, total, sum);
          });
        });
      }

      const options = angular.copy(dataOptions);
      options.idStage = stage.id;
      options.offset = stage.count;
      options.limit = 25;
      options.orderBy = ticketSortingOptions.property;
      options.coerceTo = ticketSortingOptions.property === 'name' ? 'string' : 'number';
      options.isDescending = ticketSortingOptions.isDescending;
      ticketsService.getByWorkflowAndStage(options).then((tickets) => {
        stageProcess(stagesData.available, stage.id, tickets.length);
        ticketsProcess(workflowsData, ticketsData, tickets).then((res) => {
          deferred.resolve(res);
        });
      });
    });

    return deferred.promise;
  };

  const ticketUpdateLabels = (workflowsData, ticket, idLabels) => {
    const stageModel = _.find(workflowsData.stages, (s) => s.id === ticket.idStage);
    if (stageModel) {
      const ticketModel = _.find(stageModel.tickets, (t) => t.id === ticket.id);
      if (ticketModel) {
        ticketModel.idLabels = idLabels;
        ticketService.updateTicket({ id: ticketModel.id, idLabels: ticketModel.idLabels });
      }
    }
  };

  return {
    uniq,
    diff,
    boardInitialize,
    boardHeight,
    boardReset,
    cookieFilterName,
    cookieFilterContents,
    cookieFilterRead,
    cookieFilterRemove,
    cookieFilterSet,
    cookieFilter,
    stageCollapse,
    stageProcess,
    ticketMove,
    ticketMoved,
    ticketsLoad,
    ticketsProcess,
    ticketUpdateLabels
  };
};
